module.exports = __webpack_public_path__ + "static/media/om_beard_shortboxed_round__oval.a9ecbc29.png";